import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { MapPin, Phone } from "lucide-react";
import { useEffect, useState } from "react";
import SEO from "@/components/SEO";

/* -----------------------------
   Bangladesh Division & Zilla Data
------------------------------*/
const bangladeshData = {
    Dhaka: ["Dhaka", "Gazipur", "Narayanganj", "Narsingdi", "Tangail", "Kishoreganj", "Manikganj", "Munshiganj", "Faridpur", "Gopalganj", "Madaripur", "Rajbari", "Shariatpur"],
    Chattogram: ["Chattogram", "Cox's Bazar", "Comilla", "Feni", "Noakhali", "Rangamati", "Khagrachari", "Bandarban", "Brahmanbaria", "Chandpur", "Lakshmipur"],
    Rajshahi: ["Rajshahi", "Bogura", "Chapainawabganj", "Naogaon", "Natore", "Pabna", "Joypurhat", "Sirajganj"],
    Khulna: ["Khulna", "Jashore", "Satkhira", "Bagerhat", "Jhenaidah", "Magura", "Narail", "Kushtia", "Chuadanga", "Meherpur"],
    Barishal: ["Barishal", "Patuakhali", "Bhola", "Pirojpur", "Jhalokati", "Barguna"],
    Sylhet: ["Sylhet", "Moulvibazar", "Habiganj", "Sunamganj"],
    Rangpur: ["Rangpur", "Dinajpur", "Thakurgaon", "Panchagarh", "Kurigram", "Gaibandha", "Nilphamari", "Lalmonirhat"],
    Mymensingh: ["Mymensingh", "Jamalpur", "Netrokona", "Sherpur"],
};

export default function OfflineStore() {
    const { lang } = useI18n();

    const [libraries, setLibraries] = useState([]);

    const [filters, setFilters] = useState({
        q: "",
        division: "",
        zilla: "",
    });

    const setF = (k, v) => {
        setFilters((prev) => {
            const updated = { ...prev, [k]: v };

            // যদি division change হয়, zilla reset হবে
            if (k === "division") {
                updated.zilla = "";
            }

            return updated;
        });
    };

    const loadLibraries = async () => {
        const params = new URLSearchParams();

        if (filters.q) params.append("q", filters.q);
        if (filters.division) params.append("division", filters.division);
        if (filters.zilla) params.append("zilla", filters.zilla);

        try {
            const res = await api.get(`/libraries?${params.toString()}`);
            setLibraries(res.data || []);
        } catch {
            setLibraries([]);
        }
    };

    useEffect(() => {
        loadLibraries();
    }, [filters]);

    const zillaOptions =
        filters.division ? bangladeshData[filters.division] : [];

    return (
        <div>
            <SEO title={lang === "bn" ? "আমাদের শোরুম" : "Offline Stores"} description="Find our books at libraries and stores across Bangladesh" />
            {/* HERO */}
            <section className="bg-hero-grad py-16">
                <div className="max-w-7xl mx-auto px-4">
                    <h1 className="text-4xl font-bold text-brand-navy">
                        আমাদের বইগুলো যেখান থেকে পাবেন
                    </h1>
                </div>
            </section>

            {/* SEARCH */}
            <section className="max-w-7xl mx-auto px-4 py-6">
                <div className="grid md:grid-cols-3 gap-3">

                    {/* Search */}
                    {/* <input
                        placeholder="Search name, address, phone..."
                        value={filters.q}
                        onChange={(e) => setF("q", e.target.value)}
                        className="border p-2 rounded-lg"
                    /> */}

                    {/* Division Select */}
                    <select
                        value={filters.division}
                        onChange={(e) => setF("division", e.target.value)}
                        className="border p-2 rounded-lg"
                    >
                        <option value="">Select Division</option>
                        {Object.keys(bangladeshData).map((div) => (
                            <option key={div} value={div}>
                                {div}
                            </option>
                        ))}
                    </select>

                    {/* Zilla Select (dependent) */}
                    <select
                        value={filters.zilla}
                        onChange={(e) => setF("zilla", e.target.value)}
                        className="border p-2 rounded-lg"
                        disabled={!filters.division}
                    >
                        <option value="">
                            {filters.division ? "Select Zilla" : "Select Division first"}
                        </option>

                        {zillaOptions.map((z) => (
                            <option key={z} value={z}>
                                {z}
                            </option>
                        ))}
                    </select>
                </div>
            </section>

            {/* LIST */}
            <section className="max-w-7xl mx-auto px-4 py-8">
                <div className="grid md:grid-cols-2 gap-5">

                    {libraries.map((s) => (
                        <div key={s.id} className="bg-white border rounded-2xl p-6">
                            <div className="font-bold text-lg">{s.name}</div>

                            <div className="text-xs opacity-60">
                                {s.division} • {s.zilla}
                            </div>

                            <div className="mt-3 text-sm space-y-2">
                                <div className="flex gap-2 items-start">
                                    <MapPin className="w-4 h-4 mt-1" />
                                    {s.address}
                                </div>

                                <div className="flex gap-2 items-center">
                                    <Phone className="w-4 h-4" />
                                    {s.phone}
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </section>
        </div>
    );
}